import { createDOMElement } from '../../helpers/fixtureUtils';
import './index.scss';
export default class TabView {
    constructor() {
        
    }

    createElement(parent, className, id,innerHTML) {
        const dom = {
          ele: "div",
          attributes: {
            class: className,
            id: id
          },
          parent,
          innerHTML
        }
        const element = createDOMElement(dom);
        return element;
    }

    render(parentClass, sportId, reloadSport, sportsConfig) {
        let parentContainer = document.getElementsByClassName(parentClass)[0]
        const tabViewContainer = this.createElement(parentContainer, "tab-view-container", "tab-container");
        this.tabAll = this.createElement(tabViewContainer, "tab-view-all-cont tab-view-element","","ALL");
        this.tabAll.addEventListener("click", (e) => {
          e.stopPropagation();
          if(!this.tabAll.classList.contains("tab-view-selected")){
            reloadSport("-1", "-1");
            this.tabAll.classList.add("tab-view-selected");
          }
        });

        if(sportsConfig["football"]){
          this.tabSoccer = this.createElement(tabViewContainer, "tab-view-soccer-cont tab-view-element","","Soccer");
          this.tabSoccer.addEventListener("click", (e) => {
            e.stopPropagation();
            if(!this.tabSoccer.classList.contains("tab-view-selected")){
              reloadSport("2", "-1");
              this.tabSoccer.classList.add("tab-view-selected");
            }
          });
        }
        
        if(sportsConfig["cricket"]){
          this.tabCricket = this.createElement(tabViewContainer, "tab-view-cricket-cont tab-view-element","","Cricket");
          this.tabCricket.addEventListener("click", (e) => {
            e.stopPropagation();
            if(!this.tabCricket.classList.contains("tab-view-selected")){
              reloadSport("1", "-1");
              this.tabCricket.classList.add("tab-view-selected");
            }
          });
        }

        if(sportsConfig["tennis"]){
          this.tabTennis = this.createElement(tabViewContainer, "tab-view-tennis-cont tab-view-element","","Tennis");
          this.tabTennis.addEventListener("click", (e) => {
            e.stopPropagation();
            if(!this.tabTennis.classList.contains("tab-view-selected")){
              reloadSport("3", "-1");
              this.tabTennis.classList.add("tab-view-selected");
            }
          });
        }

        switch(sportId) {
          case "-1":
              this.tabAll.classList.add("tab-view-selected");
              break;
          case "1":
              this.tabCricket.classList.add("tab-view-selected");
              break;
          case "2":
              this.tabSoccer.classList.add("tab-view-selected");
              break;
          case "3":
              this.tabTennis.classList.add("tab-view-selected");
              break;  
            default:
            // TODO define fallback
        }
    }
}